import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import WebSocketManager from "./client.js";

export function usePermissionUpdates({ user, fetchUser }) {
  const location = useLocation();
  const isPrintRoute = location.pathname.startsWith("/comprovante");

  useEffect(() => {
    if (!user?.id || isPrintRoute) return;

    const topic = `/topic/permissions-${user.id}`;

    const callback = () => {
      fetchUser();
    };

    WebSocketManager.subscribe(topic, callback);

    return () => {
      WebSocketManager.unsubscribe(topic);
    };
  }, [user, fetchUser, isPrintRoute]);
}
